import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DadosFormList } from './dados-form/dados-form';
import { DadosFormStore } from './dados-form/dados-form.store';



@Injectable({providedIn:'root'})
export class HomeListResolver implements Resolve<Observable<DadosFormList[]>>{
    constructor(
        private store:DadosFormStore
    ){}

    resolve(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):Observable<DadosFormList[]>{
        this.store.initState("0", "5", "", 5);
        return;
    }
}